module.exports = "<p-confirmDialog key=\"{{key}}\" width=\"300\" acceptLabel=\"{{('yes') | translate}}\" rejectLabel=\"{{('no') | translate}}\" [closable]=\"false\"></p-confirmDialog>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/confirm/confirm.component.html
// module id = ../../../../../src/app/shared/component/confirm/confirm.component.html
// module chunks = main